import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";
import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/Footer";

const PrivacyPolicy = () => {
  return (
    <Box sx={{ py: 2 }}>
      <Navbar page={"privacy-policy"} />
      <Box
        sx={{
          py: 7,
          px: 3,
          marginBottom: 10,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 5,
        }}
      >
        <Box>
          <Typography
            variant="h4"
            gutterBottom
            fontWeight="bold"
            textAlign="center"
          >
            Política de Privacidad
          </Typography>

          <Typography
            variant="subtitle1"
            color="text.secondary"
            gutterBottom
            textAlign="center"
          >
            Última actualización: 9 de julio de 2025
          </Typography>
          <Divider
            sx={{
              my: 2,
              borderBottomWidth: 2,
              borderColor: "#e7ef7d",
            }}
          />
        </Box>
        <Container maxWidth="md">
          <Typography variant="body1" paragraph align="justify">
            En Radaria nos comprometemos a proteger la privacidad de nuestros
            usuarios. Esta Política de Privacidad describe cómo recopilamos,
            utilizamos, almacenamos y compartimos tus datos personales cuando
            usas nuestra aplicación móvil y servicios relacionados. Al utilizar
            Radaria, aceptas las prácticas descritas en esta Política de
            Privacidad.
          </Typography>
          <Box sx={{ my: 4 }}>
            <Typography variant="h6" gutterBottom color="#e7ef7d">
              1. INFORMACIÓN QUE RECOPILAMOS
            </Typography>
            <Typography paragraph>
              Podemos recopilar los siguientes tipos de información:
            </Typography>
            <ul>
              <li>
                <strong>Información personal:</strong>
                <p>
                  Nombre, correo electrónico, número de teléfono, fecha de
                  nacimiento y género.
                </p>
              </li>
              <li>
                <strong>Datos de salud y rendimiento:</strong>

                <p>
                  Información relacionada con tus entrenamientos, hábitos
                  alimenticios, historial de lesiones, estado físico, objetivos
                  deportivos, evaluaciones nutricionales y/o fisioterapéuticas
                </p>
              </li>
              <li>
                <strong>Información de ubicación:</strong>
                <p>
                  Para funciones como selección de rutas, reporte de incidencias
                  y botón de pánico.
                </p>
              </li>
              <li>
                <strong>Datos técnicos:</strong>
                <p>
                  Tipo de dispositivo, sistema operativo, dirección IP,
                  actividad dentro de la app, y datos de diagnóstico.
                </p>
              </li>
              <li>
                <strong>Información de pago:</strong>
                <p>
                  Si accedes a servicios pagados, podremos procesar datos
                  necesarios para la transacción (a través de terceros seguros).
                </p>
              </li>
            </ul>
          </Box>
          <Box sx={{ my: 4 }}>
            <Typography variant="h6" gutterBottom color="#e7ef7d">
              2. CÓMO USAMOS TU INFORMACIÓN
            </Typography>
            <Typography paragraph>Usamos tus datos para:</Typography>
            <ul>
              <li>
                <p>
                  Personalizar tus recomendaciones y planes (nutrición,
                  fisioterapia, entrenamiento)
                </p>
              </li>
              <li>
                <p>
                  Mostrarte rutas seguras para correr y gestionar incidencias
                  reportadas.
                </p>
              </li>
              <li>
                <p>
                  Brindarte acceso a servicios de recuperación y atención
                  integral.
                </p>
              </li>
              <li>
                <p>Comunicarte promociones, descuentos y eventos deportivos.</p>
              </li>
              <li>
                <p>
                  Analizar el uso de la app para mejorar nuestros servicios.
                </p>
              </li>
              <li>
                <p>Cumplir con nuestras obligaciones legales y de seguridad.</p>
              </li>
            </ul>
          </Box>
          <Box sx={{ my: 4 }}>
            <Typography variant="h6" gutterBottom color="#e7ef7d">
              3. COMPARTICIÓN DE INFORMACIÓN
            </Typography>
            <Typography paragraph>
              Podemos compartir tu información con:
            </Typography>
            <ul>
              <li>
                <p>
                  Profesionales de salud (nutriólogos, fisioterapeutas,
                  entrenadores) afiliados a Radaria.
                </p>
              </li>
              <li>
                <p>
                  Terceros proveedores de servicios (plataformas de pago,
                  alojamiento, analítica).
                </p>
              </li>
              <li>
                <p>Autoridades competentes cuando sea requerido por ley.</p>
              </li>

              <li>
                <p>
                  Aliados comerciales o marcas deportivas, solo con tu
                  consentimiento expreso.
                </p>
              </li>
            </ul>
          </Box>
          <Box sx={{ my: 4 }}>
            <Typography variant="h6" gutterBottom color="#e7ef7d">
              4. SEGURIDAD DE LOS DATOS
            </Typography>
            <Typography paragraph>
              Aplicamos medidas de seguridad administrativas, técnicas y físicas
              para proteger tus datos personales contra pérdida, robo, acceso no
              autorizado o mal uso.
            </Typography>
          </Box>
          <Box sx={{ my: 4 }}>
            <Typography variant="h6" gutterBottom color="#e7ef7d">
              5. TUS DERECHOS Y OPCIONES
            </Typography>
            <Typography paragraph>Tienes derecho a:</Typography>
            <ul>
              <li>
                <p>Acceder a los datos que tenemos sobre ti.</p>
              </li>
              <li>
                <p>Solicitar la rectificación o eliminación de tus datos.</p>
              </li>
              <li>
                <p>Retirar tu consentimiento en cualquier momento.</p>
              </li>

              <li>
                <p>
                  Oponerte al tratamiento de tus datos para ciertos fines (como
                  marketing).
                </p>
              </li>
            </ul>
            <Typography paragraph>
              Puedes ejercer estos derechos escribiéndonos a:{" "}
              <strong>hola@radaria.mx</strong>
            </Typography>
          </Box>
          <Box sx={{ my: 4 }}>
            <Typography variant="h6" gutterBottom color="#e7ef7d">
              6. RETENCIÓN DE DATOS
            </Typography>
            <Typography paragraph>
              Conservamos tu información mientras mantengas una cuenta activa o
              mientras sea necesario para proporcionarte nuestros servicios.
              También podemos conservar cierta información para cumplir con
              obligaciones legales.
            </Typography>
          </Box>
          <Box sx={{ my: 4 }}>
            <Typography variant="h6" gutterBottom color="#e7ef7d">
              7. COOKIES Y TECNOLOGÍAS SIMILARES
            </Typography>
            <Typography paragraph>
              Nuestra app puede usar cookies o identificadores similares para
              mejorar tu experiencia y obtener estadísticas de uso.
            </Typography>
          </Box>
          <Box sx={{ my: 4 }}>
            <Typography variant="h6" gutterBottom color="#e7ef7d">
              8. MENORES DE EDAD
            </Typography>
            <Typography paragraph>
              Radaria no está dirigida a menores de 18 años. Si eres padre,
              madre o tutor y crees que hemos recopilado datos de un menor, por
              favor contáctanos.
            </Typography>
          </Box>
          <Box sx={{ my: 4 }}>
            <Typography variant="h6" gutterBottom color="#e7ef7d">
              9. CAMBIOS A ESTA POLÍTICA
            </Typography>
            <Typography paragraph>
              Podremos actualizar esta política en el futuro. Notificaremos
              cualquier cambio significativo dentro de la aplicación o por
              correo electrónico.
            </Typography>
          </Box>

          <Box sx={{ my: 4, display: "flex", justifyContent: "center" }}>
            <Box
              sx={{
                backgroundColor: "rgba(212, 216, 216, 0.32)",
                width: 400,
                height: 200,
                borderRadius: 5,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                variant="body1"
                paragraph
                align="center"
                color="#e7ef7d"
              >
                Si tienes dudas sobre esta política, contáctanos:
              </Typography>
              <Box>
                <Typography
                  variant="body1"
                  paragraph
                  align="center"
                  fontWeight={"bold"}
                >
                  Radaria S.A.P.I. de C.V.
                </Typography>
                <Typography variant="body1" paragraph align="center">
                  Correo electrónico: <strong>melissa@radaria.mx</strong>
                </Typography>
                <Typography variant="body1" paragraph align="center">
                  Dirección: <strong>Avenida Ejército Nacional 622</strong>
                </Typography>
              </Box>
            </Box>
          </Box>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
};

export default PrivacyPolicy;
